"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var MentionOption = antd_1.Mentions.Option;
var ColorField_1 = __importDefault(require("../Field/ColorField/ColorField"));
var OpacityField_1 = __importDefault(require("../Field/OpacityField/OpacityField"));
var WidthField_1 = __importDefault(require("../Field/WidthField/WidthField"));
var FontPicker_1 = __importDefault(require("../Field/FontPicker/FontPicker"));
var OffsetField_1 = __importDefault(require("../Field/OffsetField/OffsetField"));
var RotateField_1 = __importDefault(require("../Field/RotateField/RotateField"));
var CompositionContext_1 = require("../../CompositionContext/CompositionContext");
var CompositionUtil_1 = __importDefault(require("../../../Util/CompositionUtil"));
var _cloneDeep = require('lodash/cloneDeep');
var _isEqual = require('lodash/isEqual');
require("./TextEditor.css");
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
/**
 * The TextEditor class. Allows to edit text styles based on a template string
 * where words wrapped in double curly braces ({{}}) will be understood as
 * feature properties and text without curly braces as static text.
 */
var TextEditor = /** @class */ (function (_super) {
    __extends(TextEditor, _super);
    function TextEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onLabelChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.label = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onColorChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.color = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onFontChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.font = value.length > 0 ? value : undefined;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onOpacityChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.opacity = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onSizeChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.size = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onOffsetXChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            var newOffset = [value, (symbolizer.offset ? symbolizer.offset[1] : 0)];
            symbolizer.offset = newOffset;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onOffsetYChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            var newOffset = [(symbolizer.offset ? symbolizer.offset[0] : 0), value];
            symbolizer.offset = newOffset;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onRotateChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.rotate = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onHaloColorChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.haloColor = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onHaloWidthChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.haloWidth = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        /**
         * Wraps a Form Item around a given element and adds its locale
         * to the From Item label.
         */
        _this.wrapFormItem = function (locale, element) {
            var formItemLayout = {
                labelCol: { span: 8 },
                wrapperCol: { span: 16 }
            };
            return element == null ? null : (React.createElement(antd_1.Form.Item, __assign({ label: locale }, formItemLayout), element));
        };
        return _this;
    }
    TextEditor.prototype.shouldComponentUpdate = function (nextProps) {
        var diffProps = !_isEqual(this.props, nextProps);
        return diffProps;
    };
    TextEditor.prototype.render = function () {
        var _this = this;
        var _a = this.props, locale = _a.locale, internalDataDef = _a.internalDataDef;
        var symbolizer = _cloneDeep(this.props.symbolizer);
        var opacity = symbolizer.opacity, color = symbolizer.color, font = symbolizer.font, offset = symbolizer.offset, size = symbolizer.size, rotate = symbolizer.rotate, haloColor = symbolizer.haloColor, haloWidth = symbolizer.haloWidth;
        // split the current offset
        var offsetX;
        var offsetY;
        if (offset) {
            offsetX = offset[0];
            offsetY = offset[1];
        }
        var properties = internalDataDef && internalDataDef.schema ? Object.keys(internalDataDef.schema.properties) : [];
        return (React.createElement(CompositionContext_1.CompositionContext.Consumer, null, function (composition) { return (React.createElement("div", { className: "gs-text-symbolizer-editor" },
            _this.wrapFormItem(locale.templateFieldLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'TextEditor.templateField',
                onChange: _this.onLabelChange,
                propName: 'value',
                propValue: symbolizer.label || '',
                defaultElement: (React.createElement(antd_1.Mentions, { placeholder: locale.templateFieldLabel, prefix: "{{", notFoundContent: locale.attributeNotFound }, properties.map(function (p) { return React.createElement(MentionOption, { key: p, value: p }, p); })))
            })),
            _this.wrapFormItem(locale.colorLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'TextEditor.colorField',
                onChange: _this.onColorChange,
                propName: 'color',
                propValue: color,
                defaultElement: React.createElement(ColorField_1.default, null)
            })),
            _this.wrapFormItem(locale.fontLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'TextEditor.fontField',
                onChange: _this.onFontChange,
                propName: 'font',
                propValue: font,
                defaultElement: React.createElement(FontPicker_1.default, null)
            })),
            _this.wrapFormItem(locale.opacityLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'TextEditor.opacityField',
                onChange: _this.onOpacityChange,
                propName: 'opacity',
                propValue: opacity,
                defaultElement: React.createElement(OpacityField_1.default, null)
            })),
            _this.wrapFormItem(locale.sizeLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'TextEditor.sizeField',
                onChange: _this.onSizeChange,
                propName: 'width',
                propValue: size,
                defaultElement: React.createElement(WidthField_1.default, null)
            })),
            _this.wrapFormItem(locale.offsetXLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'TextEditor.offsetXField',
                onChange: _this.onOffsetXChange,
                propName: 'offset',
                propValue: offsetX,
                defaultElement: React.createElement(OffsetField_1.default, null)
            })),
            _this.wrapFormItem(locale.offsetYLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'TextEditor.offsetYField',
                onChange: _this.onOffsetYChange,
                propName: 'offset',
                propValue: offsetY,
                defaultElement: React.createElement(OffsetField_1.default, null)
            })),
            _this.wrapFormItem(locale.rotateLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'TextEditor.rotateField',
                onChange: _this.onRotateChange,
                propName: 'rotate',
                propValue: rotate,
                defaultElement: React.createElement(RotateField_1.default, null)
            })),
            _this.wrapFormItem(locale.haloColorLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'TextEditor.haloColorField',
                onChange: _this.onHaloColorChange,
                propName: 'color',
                propValue: haloColor,
                defaultElement: React.createElement(ColorField_1.default, null)
            })),
            _this.wrapFormItem(locale.haloWidthLabel, CompositionUtil_1.default.handleComposition({
                composition: composition,
                path: 'TextEditor.haloWidthField',
                onChange: _this.onHaloWidthChange,
                propName: 'width',
                propValue: haloWidth,
                defaultElement: React.createElement(WidthField_1.default, null)
            })))); }));
    };
    TextEditor.defaultProps = {
        locale: en_US_1.default.GsTextEditor
    };
    TextEditor.componentName = 'TextEditor';
    return TextEditor;
}(React.Component));
exports.TextEditor = TextEditor;
exports.default = LocaleWrapper_1.localize(TextEditor, TextEditor.componentName);
//# sourceMappingURL=TextEditor.js.map